import { timelineNodes } from '@/mocks/gua88-news';
import { SectionHead } from './articleUi';

export default function Timeline() {
  return (
    <section id="timeline" className="border-b border-background-200 bg-background-50 py-14 md:py-20">
      <div className="mx-auto max-w-6xl px-4 md:px-6">
        <SectionHead
          kicker="Recap · 前情补课"
          title="事件时间线"
          desc="从初曝到发酵、再到现阶段的多次回应，所有关键节点按时间排序。新蹲的朋友看完这一节就能接上剧情。"
        />

        <div className="grid grid-cols-1 gap-10 lg:grid-cols-[1fr_320px]">
          {/* vertical timeline */}
          <ol className="relative ml-3 border-l border-background-300 pl-8">
            {timelineNodes.map((n, i) => {
              const milestone = i === 2 || i === 5 || i === 6;
              return (
                <li key={n.date} className="relative pb-8 last:pb-0">
                  <span
                    className={`absolute -left-[45px] flex h-4 w-4 items-center justify-center rounded-full ring-4 ring-background-50 ${
                      milestone ? 'bg-accent-500' : 'bg-primary-400'
                    }`}
                  ></span>
                  <div className="flex flex-wrap items-center gap-2">
                    <span className="rounded-full bg-secondary-100 px-2.5 py-0.5 text-xs font-medium text-secondary-900">
                      {n.date}
                    </span>
                    <span className="font-display text-sm text-primary-500">{n.time}</span>
                  </div>
                  <h4 className="mt-2 font-heading text-base font-bold text-foreground-950 md:text-lg">
                    {n.title}
                  </h4>
                  <p className="mt-1.5 max-w-xl text-sm leading-relaxed text-foreground-600">
                    {n.desc}
                  </p>
                </li>
              );
            })}

            <li className="relative pl-0">
              <span className="absolute -left-[41px] flex h-2.5 w-2.5 items-center justify-center rounded-full bg-primary-500">
                <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-primary-500 opacity-70"></span>
              </span>
              <p className="ml-1 inline-flex items-center gap-2 rounded-full border border-background-300 bg-background-100 px-3 py-1.5 text-xs text-foreground-700">
                <i className="ri-loader-4-line animate-spin text-primary-500"></i>
                时间线仍在更新，新节点会持续追加…
              </p>
            </li>
          </ol>

          {/* side panel: 前情提要 */}
          <aside className="lg:pt-1">
            <div className="sticky top-24 rounded-lg border border-background-200 bg-background-100 p-5">
              <h3 className="font-heading text-base font-bold text-foreground-950">
                <i className="ri-chat-history-line mr-1.5 align-middle text-primary-500"></i>
                三句话看懂前情
              </h3>
              <ul className="mt-4 space-y-4">
                <li className="flex gap-3">
                  <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-primary-100 text-xs font-bold text-primary-700">
                    1
                  </span>
                  <p className="text-sm leading-relaxed text-foreground-700">
                    一次互动截图被广泛转发，事件进入大众视野并快速出圈。
                  </p>
                </li>
                <li className="flex gap-3">
                  <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-accent-100 text-xs font-bold text-accent-900">
                    2
                  </span>
                  <p className="text-sm leading-relaxed text-foreground-700">
                    双方隔空交锋，录音与细节片段引发多轮反转与误读。
                  </p>
                </li>
                <li className="flex gap-3">
                  <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-secondary-100 text-xs font-bold text-secondary-900">
                    3
                  </span>
                  <p className="text-sm leading-relaxed text-foreground-700">
                    现阶段各执一词，官方回应与新的佐证仍未完全落地，剧情尚有悬念。
                  </p>
                </li>
              </ul>
              <a
                href="#feed"
                className="mt-5 inline-flex w-full items-center justify-center whitespace-nowrap rounded-full border border-background-300 bg-background-50 px-4 py-2 text-sm text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-700"
              >
                接着看续集新料
                <i className="ri-arrow-down-line ml-1.5"></i>
              </a>
            </div>
          </aside>
        </div>
      </div>
    </section>
  );
}